import React from "react";

//Local Libraries
import phrasebookLoad from "../../i18n"; import { gisRoutes } from "../../routes/routes";
import * as token from '../../helpers/token';
import { accountTypesConstants } from '../../constants';
import { capitalizeFirstLetter } from '../../helpers/util';
import contacts from '../../constants/contacts.constants.json';

//Components
import { NewBreadcrumbs } from "../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
// Constants
const phrasebook = phrasebookLoad()
class Contacts extends React.Component {
  constructor(props) {
    super(props);
    this.contacts = contacts;
    this.departments = Object.keys(contacts);
  }

  listContacts = () => {
    var view = []
    this.departments.map(key => {
      var emails = []
      var phones = []
      this.contacts[key].email.map(emailto => emails.push(<a href={`mailto:${emailto}`}>{emailto}</a>))
      if (this.contacts[key].contact.length > 0) this.contacts[key].contact.map(phone => phones.push(<a href="">{phone}</a>));
      view.push(<div class="list-item-desc">
        <h4>{capitalizeFirstLetter(key)}</h4>
        <p><strong>Email:</strong>{emails.map((email, index) => index != 0 ? <p>{email}</p> : email)}</p>
        {phones.length > 0 ? <><p><strong>Contact:</strong>{phones.map((phone, index) => index != 0 ? <p>{phone}</p> : phone)}</p></> : null}

      </div>)
    })
    return view;
  }

  render() {
    return (<>
      <div className="box p-1 p-sm-2">
        <h2 className="box-title pb-1 mb-1">{phrasebook.headerlinks.support_contacts}</h2>
        <div class="list-item-group">
          {this.listContacts()}
          {/* <div class="list-item-desc">
            <h4>Sales</h4>
            <p><strong>Email:</strong> <a href={`mailto:jng@pccwglobal.com`}>jng@pccwglobal.com</a>, <a href={`mailto:shkwong@pccwglobal.com`}>shkwong@pccwglobal.com</a></p>
          </div>

          <div class="list-item-desc">
            <h4>Product</h4>
            <p><strong>Email:</strong> <a href={"mailto:hcchan@pccwglobal.com"}>hcchan@pccwglobal.com</a>, <a href={"mailto:wchan@pccwglobal.com"}>wchan@pccwglobal.com</a>, <a href={"mailto:sylee@pccwglobal.com"}>sylee@pccwglobal.com</a></p>
          </div>

          <div class="list-item-desc">
            <h4>Operations</h4>
            <p><strong>Email:</strong> <a href={"mailto:VoiceNoc@pccwglobal.com"}>VoiceNoc@pccwglobal.com</a>, <strong>Contact:</strong><a href="">+85222141918</a></p>
          </div> */}
        </div>
      </div >
    </>);
  }
}

export default (Contacts);
